module.exports = __webpack_public_path__ + "img/b.5a80f2e9.jpg";